import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 3,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const stored = localStorage.getItem('countdown_end');
    let endTime: number;
    if (stored) {
      endTime = parseInt(stored, 10);
    } else {
      endTime = Date.now() + 72 * 60 * 60 * 1000;
      localStorage.setItem('countdown_end', endTime.toString());
    }
    const tick = () => {
      const diff = Math.max(0, endTime - Date.now());
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const m = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const s = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        days: d,
        hours: h,
        minutes: m,
        seconds: s
      });
    };
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#7B1D1D] border-t border-gold/20 py-3 px-4 shadow-[0_-4px_20px_rgba(0,0,0,0.4)]" data-id="element-34">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-35">
        {/* Left: urgency + timer */}
        <div className="flex items-center gap-3 sm:gap-4" data-id="element-36">
          <span className="text-sm sm:text-base font-semibold text-gold-light whitespace-nowrap" data-id="element-37">
            🔥 Precio de lanzamiento
          </span>
          <div className="flex items-center gap-1.5" data-id="element-38">
            {[{
            value: pad(timeLeft.days),
            label: 'días'
          }, {
            value: pad(timeLeft.hours),
            label: 'hs'
          }, {
            value: pad(timeLeft.minutes),
            label: 'min'
          }, {
            value: pad(timeLeft.seconds),
            label: 'seg'
          }].map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-39">
                <span className="bg-charcoal/80 text-white font-bold text-sm sm:text-base tabular-nums px-2 py-1 rounded min-w-[32px] text-center" data-id="element-40">
                  {unit.value}
                </span>
                <span className="text-[10px] text-cream-muted/60 mt-0.5" data-id="element-41">
                  {unit.label}
                </span>
              </div>)}
          </div>
        </div>

        {/* Right: CTA button */}
        <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="group inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full transition-all duration-200 shadow-[0_0_20px_rgba(212,168,83,0.3)] whitespace-nowrap" data-id="element-42">
          Quiero empezar ahora
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-43" />
        </motion.a>
      </div>
    </div>;
}